module.exports = __webpack_public_path__ + "img/noDate.f229da41.png";